exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.s-guidance-pop img {\r\n  height: 270px;\r\n  vertical-align: middle;\n}\n.s-guidance-pop a,\r\n.s-guidance span {\r\n  color: var(--prev-color-primary);\r\n  cursor: pointer;\n}\r\n", ""]);

// exports
